// biome-ignore lint/correctness/noUnusedImports: React is required for JSX
import React, { createContext, useContext } from "react";

const StrapiDataContext = createContext({});

export const StrapiDataProvider = ({ children, pageContext }) => {
  const { globalData, footerData, allLandings, allPages, stepFormData, discountCodes } =
    pageContext || {};

  return (
    <StrapiDataContext.Provider
      value={{ globalData, footerData, allLandings, allPages, stepFormData, discountCodes }}
    >
      {children}
    </StrapiDataContext.Provider>
  );
};

export const useStrapiData = () => useContext(StrapiDataContext);

export const useGlobalData = () => useStrapiData().globalData;

export const useFooterData = () => useStrapiData().footerData;

export const useAllLandings = () => useStrapiData().allLandings;

export const useAllPages = () => useStrapiData().allPages;

export const useStepFormData = () => useStrapiData().stepFormData;

export const useDiscountCodes = () => useStrapiData().discountCodes || [];

export const useGoogleRating = () => useGlobalData()?.googleRating;
